import {
  Button,
  Collapse,
  ListItemIcon,
  ListItemText,
  MenuItem,
  MenuList,
} from '@mui/material'
import ExpandLess from '@mui/icons-material/ExpandLess'
import ExpandMore from '@mui/icons-material/ExpandMore'
import ToggleOnIcon from '@mui/icons-material/ToggleOn'
import { useRouter } from 'next/router'
import React, { FC, useState } from 'react'
import { useIntl } from 'react-intl'
// @todo external
import { TtoggleDrawerOnMobile } from '../../../../containers/Sidebar/Sidebar'
// @todo external
import { MenuFeatures } from './features'
import { useStyles } from '../../../../containers/Sidebar/Sidebar.styles'
import { permissionValidation } from '@novafuturltd/shared'

interface Props {
  permissions: string[]
  openDrawer: boolean
  hoverDrawer: boolean
  toggleDrawerOnMobile: TtoggleDrawerOnMobile
  toggleOpen: (open: boolean) => void
}

const HrBotBoSubMenu: FC<Props> = ({
  permissions,
  openDrawer,
  hoverDrawer,
  toggleDrawerOnMobile,
  toggleOpen,
}) => {
  const intl = useIntl()
  const classes = useStyles({ openDrawer, hoverDrawer })
  const { pathname } = useRouter()
  const [open, setOpen] = useState(pathname.includes('toggle-feature/'))
  const handleClick = () => {
    setOpen(!open)
  }

  return permissionValidation(permissions, 'feature_toggle') ? (
    <MenuList aria-labelledby="nested-list-subheader" className={classes.root}>
      <MenuItem
        key="feature_toggle"
        data-test="feature_toggle_sidebar_submenu"
        component={Button}
        onClick={handleClick}
        className={classes.menuItem}
        selected={
          !openDrawer && !hoverDrawer && pathname.includes('toggle-feature/')
        }
      >
        <ListItemIcon data-test="feature_toggle_sidemenu_icon">
          <ToggleOnIcon
            style={{ fill: '#F59C0D', width: '24px', height: '24px' }}
          />
        </ListItemIcon>
        <ListItemText
          primary={intl.formatMessage({ id: 'toggle-features.sidebar' })}
          hidden={!openDrawer && !hoverDrawer}
        />
        {open ? (
          <ExpandLess
            onClick={() => toggleOpen(true)}
            className={classes.expandIcon}
          />
        ) : (
          <ExpandMore
            onClick={() => toggleOpen(true)}
            className={classes.expandIcon}
          />
        )}
      </MenuItem>
      <Collapse in={open} timeout="auto" hidden={!openDrawer && !hoverDrawer}>
        <MenuList disablePadding={true}>
          {permissionValidation(permissions, 'feature_toggle.features') && (
            <MenuFeatures
              pathname={pathname}
              nested={
                openDrawer || hoverDrawer
                  ? classes.nested
                  : classes.nestedClosed
              }
              toggleDrawerOnMobile={toggleDrawerOnMobile}
            />
          )}
        </MenuList>
      </Collapse>
    </MenuList>
  ) : null
}

export default HrBotBoSubMenu
